import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function ApplySuccess() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  return (
    <div className="bg-mist min-h-screen">
      <div className="container-x mx-auto max-w-3xl pt-20 md:pt-28 pb-24">
        <div className="rounded-3xl bg-white border border-black/5 p-8 md:p-14 text-center" data-testid="apply-success">
          <span className="inline-grid place-items-center h-16 w-16 rounded-full bg-bright/15 text-forest mb-6">
            <CheckCircle2 size={30} strokeWidth={2}/>
          </span>
          <h1 className="font-heading text-3xl md:text-5xl font-semibold text-forest leading-[1.05]">Application received</h1>
          <p className="mt-4 text-neutral-600 text-[16px] leading-relaxed max-w-xl mx-auto">
            Thank you. Our team will review your business energy usage and site details. If your
            business appears suitable, we will contact you to discuss the next step.
          </p>
          {ref && (
            <p className="mt-6 text-[13px] text-neutral-500">
              Your reference: <span className="font-semibold text-forest">{ref}</span>
            </p>
          )}
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full h-11 px-5 border border-forest/20 text-forest font-semibold hover:bg-mist transition-colors"
            >
              Back to homepage
            </Link>
            <Link
              to="/how-it-works"
              className="inline-flex items-center gap-2 rounded-full h-11 px-5 bg-forest text-white font-semibold hover:brightness-110 transition"
            >
              What happens next <ArrowRight size={16}/>
            </Link>
          </div>
          <p className="mt-10 text-[12px] text-neutral-500 leading-relaxed max-w-2xl mx-auto">
            Information provided by Be Green Group is general and indicative only. Eligibility,
            pricing, savings and system suitability are subject to business energy usage, site
            conditions, credit approval, network requirements, funding approval and final contract terms.
          </p>
        </div>
      </div>
    </div>
  );
}
